import { 
    Field, 
    FieldValue, 
    FieldValueCheckbox, 
    FieldValueYesNo, 
    FieldValueTextarea, 
    FieldValueText, 
    FieldValueDouble, 
    FieldValueDropdown, 
    FieldValueInteger, 
    FieldValueDateTime, 
    FieldValueMedia,
    FieldValueLocaleMedia,
    FieldValueLocaleText,
    FieldValueTags,
    FieldValueLocaleTextarea,
    FieldValueCollection,
    FieldValueProduct,
    FieldValuePropertyPicker,
    FieldValueCheckboxList,
    FieldValueLocalTextList
} from "typings";

export const isCheckbox = (field: Field, value: FieldValue<any>): value is FieldValueCheckbox => 
    field.field.fieldType.id === "checkbox";

export const isYesNo = (field: Field, value: FieldValue<any>): value is FieldValueYesNo => 
    field.field.fieldType.id === "yesno";

export const isTextarea = (field: Field, value: FieldValue<any>): value is FieldValueTextarea => 
    field.field.fieldType.id === "textarea";

export const isLocaleTextarea = (field: Field, value: FieldValue<any>): value is FieldValueLocaleTextarea => 
    field.field.fieldType.id === "locale_textarea";

export const isDropdown = (field: Field, value: FieldValue<any>): value is FieldValueDropdown => 
    field.field.fieldType.id === "text_dropdown" ||   field.field.fieldType.id === "text_locale_dropdown";

export const isString = (field: Field, value: FieldValue<any>): value is FieldValueText => 
    field.field.fieldType.id === "text";

export const isDouble = (field: Field, value: FieldValue<any>): value is FieldValueDouble => 
    field.field.fieldType.id === "double";

export const isInteger = (field: Field, value: FieldValue<any>): value is FieldValueInteger => 
    field.field.fieldType.id === "integer";

export const isDateTime = (field: Field, value: FieldValue<any>): value is FieldValueDateTime => 
    field.field.fieldType.id === "datetime";

export const isLabel = (field: Field, value: FieldValue<any>): value is FieldValueText => 
    field.field.fieldType.id === "label_text" || field.field.fieldType.id === "label_integer";

export const isFile = (field: Field, value: FieldValue<any>): value is FieldValueText => 
    field.field.fieldType.id === "file";

export const isYoutube = (field: Field, value: FieldValue<any>): value is FieldValueText => 
    field.field.fieldType.id === "youtube";

export const isMediaPicker = (field: Field, value: FieldValue<any>): value is FieldValueMedia => 
    field.field.fieldType.id === "media";

export const isLocaleMediaPicker = (field: Field, value: FieldValue<any>): value is FieldValueLocaleMedia =>
    field.field.fieldType.id === "locale_media";

export const isLocaleText = (field: Field, value: FieldValue<any>): value is FieldValueLocaleText => 
    field.field.fieldType.id === "locale_text";

export const isTags = (field: Field, value: FieldValue<any>): value is FieldValueTags => 
    field.field.fieldType.id === "tags";

export const isCollectionPicker = (field: Field, value: FieldValue<any>): value is FieldValueCollection => 
    field.field.fieldType.id === "collection";

export const isProductPicker = (field: Field, value: FieldValue<any>): value is FieldValueProduct => 
    field.field.fieldType.id === "product_picker";

export const isPropertyPicker = (field: Field, value: FieldValue<any>): value is FieldValuePropertyPicker => 
    field.field.fieldType.id === "property_picker";

export const isCheckBoxList = (field: Field, value: FieldValue<any>): value is FieldValueCheckboxList => 
    field.field.fieldType.id === "checkbox_list";

export const isLocaleTextList = (field: Field, value: FieldValue<any>): value is FieldValueLocalTextList => 
    field.field.fieldType.id === "locale_text_list";


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/FieldHelper.ts